import { Navigate, useLocation } from 'react-router-dom';
import type { ReactElement } from 'react';
import { useAuth } from '../contexts/AuthContext';

interface Props {
  children: ReactElement;
  // Si está, además de exigir login se chequea que el user tenga este role.
  // Si el user no tiene el role correcto → redirect a / (dashboard).
  requireRole?: 'admin';
}

export function ProtectedRoute({ children, requireRole }: Props): ReactElement {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-surface-base">
        <div className="text-ink-subtle text-sm font-mono">Cargando…</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  // Defensa de UI — el backend igual valida con requireAdmin middleware.
  // Si el user no tiene el rol requerido, lo mandamos al dashboard.
  if (requireRole && user.role !== requireRole) {
    return <Navigate to="/" replace />;
  }

  return children;
}
